<template>
    <b-row class="m-0 h-100 w-100 justify-content-center">
        <b-col cols="12" class="p-3  h-100 text-left">
            <!-- <div class="pt-5 pb-5">
                <p class="text-left h3  p-1 text-blod text-primary text-center" >{{register.layoutTitle}}</p>
            </div> @submit="onSubmit"-->
            <b-form  @reset="onReset" novalidate>
                <template v-for="(field,index) in formFields" >
                    <b-form-group :id="`${field.column}-${field.type}`" 
                    :label="field.label" 
                    :label-for="`${field.column}`" 
                    v-if="field.show && field.type !== 'radio'"
                    label-size="md"  
                    label-align="right" 
                    label-cols-lg="2"
                    label-cols="3">
                         <b-form-input
                            :id="`${field.column}`"
                            v-model="field.value"
                            v-if="field.type== 'text'"
                            :type="field.type"
                            required
                            autocomplete="off"
                            :placeholder="field.placeholder"
                            :readonly="readonlyInput"
                            @change="change(field)"
                            :state="field.state"
                            ></b-form-input>

                            <b-form-textarea
                            v-if="field.type == 'textarea'"
                            :id="`${field.column}`"
                            v-model="field.value"
                            :type="field.type"
                            required
                            autocomplete="off"
                            :placeholder="field.placeholder"
                            :readonly="readonlyInput"
                            @change="change(field)"
                            :state="field.state"
                            rows="3"
                            max-rows="6"
                            ></b-form-textarea>
                        <b-form-invalid-feedback :state="field.state">
                            {{field.msg}}
                        </b-form-invalid-feedback>
                        
                        
                    </b-form-group>
                    <b-form-group  :id="`${field.column}`" 
                    :label="field.label" 
                    :label-for="`${field.column}`"
                    v-if="field.show && field.type == 'radio'"
                    label-size="md"  
                    label-align="right" 
                    label-cols-lg="2"
                    @change="change(field)"
                    label-cols="3">
                    <b-form-radio-group
                        size="lg"
                        v-model="field.value"
                        :options="field.options"
                        :name="`${field.column}`"
                    >
                    <b-form-invalid-feedback :state="field.state">
                        {{field.msg}}
                    </b-form-invalid-feedback>
                
                    </b-form-radio-group>
                    
                    
                    </b-form-group>
                </template>
                <b-form-group label-cols="3" label-cols-lg="2" label-size="lg"  label-align="right" id="password" label="密码" label-for="password">
                    <b-form-input
                    type="password"
                    id="password"
                    v-model="form.password"
                    autocomplete="new-password"
                    required
                    placeholder="请输入密码"
                    ></b-form-input>
                </b-form-group>
                <b-form-group label-cols="3" label-cols-lg="2" label-size="lg"  label-align="right" id="passwordb" label="确认密码" label-for="passwordb">
                    <b-form-input
                    type="password"
                    id="passwordb"
                    v-model="form.password"
                    autocomplete="new-password"
                    required
                    placeholder="请确认密码"
                    ></b-form-input>
                </b-form-group>
                <!-- <b-form-group id="check" label-cols="3" label-cols-lg="2">
                    <b-form-checkbox-group v-model="form.checked" id="check">
                            <b-form-checkbox value="me">我已阅读并同意
                                <b-link href="#" class="font-weight-bold">《用户协议书示例》</b-link>
                            </b-form-checkbox>
                    </b-form-checkbox-group>
                </b-form-group> -->
                <b-form-group  label-cols="3" label-cols-lg="2">
                    <b-button block variant="primary" size="lg" @click="onSubmit">注册</b-button>
                </b-form-group>
            </b-form>
            <!-- <b-form @submit="onSubmit" @reset="onReset"> -->
                <!-- <b-form-group label-cols="3" label-cols-lg="2" label-size="lg"  label-align="right" id="phone" label="手机号:" label-for="phone">
                    <b-form-input
                    id="phone"
                    v-model="form.phone"
                    autocomplete="off"
                    required
                    placeholder="请输入账号"
                    description="请输入账号"
                    ></b-form-input>
                </b-form-group>
                <b-form-group label-cols="3" label-cols-lg="2" label-size="lg"  label-align="right" id="code" label="验证码:" label-for="code">
                    <b-input-group>
                        <b-form-input
                        id="code"
                        v-model="form.phone"
                        autocomplete="off"
                        required
                        placeholder="验证码"
                        description="验证码"
                        ></b-form-input>
                            <b-button  variant="outline-primary">获取验证码</b-button>
                    </b-input-group>
                </b-form-group> -->
                <!-- <b-form-group  label-cols="3" label-cols-lg="2">
                    <b-button block type="submit" variant="primary" size="lg">注册</b-button>
                </b-form-group>
                <b-form-group label-cols="3" label-cols-lg="2" class="pt-3">
                    <b-link block  to="/login" class="font-weight-bold "> 已有账号？立即登录</b-link>
                </b-form-group> -->
                    
            <!-- </b-form> -->
            <!-- <webForm :form-type="'add'" :init-service-name="serviceName" :init-app="app"></webForm> -->
            <div class="p-5"></div>
        </b-col>
    </b-row>
  </template>
  
  <script>
  
import store from '@/store'
  import bg from '@/assets/bg.jpg'
 
//   import webForm from '@/components/form.vue'
import { getV2,setRequest } from '@/api/api.js'
import formMixin from '@/utils/form.js'
  export default {
    components: {
        // webForm
    },
    mixins:[formMixin],
    props: {
      msg: String,
      formType:{
        type:String,
        default:'add'   // add  update
      },
      initType:{
        type:String,
        default:''   // person  group
      },
      initTitle:{
        type:String,
        default:'个人会员注册'
      },
      initServiceName:{
        type:String,
        default:'srvws_member_info_reg_add'
      },
      initApp:{
        type:String,
        default:'ws'
      }
    },
    computed:{
        memberType(){
            let type = ''
            if(this.initType){
                type = this.initType
            }else if(this.loadType){
                type = this.loadType
            }
            type = type == 'group' ? '企业' : '个人'

            return type
        },
        register(){
            let config = {
                text:'注册',
                show:true,
                layoutTitle:this.initTitle,
                layoutMsg:"",
                loginPath:"/register",
            }
            if(this.webConfig.hander.register){
                config  = this.webConfig.hander.register
            }
            
            return config
        },
        registerType(){
            let type = ''
            if(this.initType){
                type = this.initType
            }else if(this.loadType){
                type = this.loadType
            }
            return type
        },
        serviceName(){
            let srv = ''
            if(this.initServiceName){
                srv = this.initServiceName
            }
            return srv
        },
        app(){
            let app = ''
            
            if(this.initApp){
                app = this.initApp
            }
            return app
        },
        logos(){
            let info = store.getters.getWebConfig['_logos']
            let logos = []
            if(Array.isArray(info) &&  info.length > 0){
                logos = info.map(item => item)
                console.log('logo register',logos)
            }
            return logos
        },
        formFields(){
            let fields = []
            if(Array.isArray(this.fields)){
                fields = this.fields.map(item => {
                    if(item.column == 'member_type'){
                        item.value = this.memberType
                    }
                    return    item
                })
            }
            

            return fields
        }
    },
    data(){
        return {
            form:{
            "password": "",
            "passwordb": "",
            "checked": [],
            "phone":'',
            "code":""
            },
            bgurl:bg,
            loadType:'',
            fields:[
                {
                    "label": "名称",
                    "column": "name",
                    "type": "text",
                    "value": null,
                    "placeholder": "请输入名称...",
                    "rules": [
                        {
                            "type": "required",
                            "trigger": "change",
                            "msg": "名称不能为空"
                        }
                    ],
                    "state": null,
                    "msg": "",
                    "show": true
                },
                {
                    "label": "省份证",
                    "column": "card_no",
                    "type": "text",
                    "value": '900',
                    "placeholder": "请输入省份证...",
                    "rules": [
                        {
                            "type": "required",
                            "trigger": "change",
                            "msg": "省份证不能为空"
                        }
                    ],
                    "state": null,
                    "msg": "",
                    "show": false
                },
                {
                    "label": "学历",
                    "column": "edu",
                    "type": "radio",
                    "value": null,
                    "placeholder": "请输入学历...",
                    "rules": [
                        {
                            "type": "required",
                            "trigger": "change",
                            "msg": "学历不能为空"
                        }
                    ],
                    "options":[{"text":"小学","value":"小学"},{"text":"初中","value":"初中"},{"text":"高中","value":"高中"},{"text":"专科","value":"专科"},{"text":"本科","value":"本科"},{"text":"研究生以上","value":"研究生以上"}],
                    "state": null,
                    "msg": "",
                    "show": true
                },
                {
                    "label": "工作单位",
                    "column": "work_unit",
                    "type": "text",
                    "value": null,
                    "placeholder": "请输入工作单位...",
                    "rules": [
                        {
                            "type": "required",
                            "trigger": "change",
                            "msg": "工作单位不能为空"
                        }
                    ],
                    "state": null,
                    "msg": "",
                    "show": true
                },
                {
                    "label": "邮箱",
                    "column": "email",
                    "type": "text",
                    "value": null,
                    "placeholder": "请输入邮箱...",
                    "rules": [
                        {
                            "type": "required",
                            "trigger": "change",
                            "msg": "邮箱不能为空"
                        }
                    ],
                    "state": null,
                    "msg": "",
                    "show": true
                },
                {
                    "label": "简历",
                    "column": "resume",
                    "type": "textarea",
                    "value": null,
                    "placeholder": "请输入简历...",
                    "rules": [
                        {
                            "type": "required",
                            "trigger": "change",
                            "msg": "简历不能为空"
                        }
                    ],
                    "state": null,
                    "msg": "",
                    "show": true
                },
                {
                    "label": "会员类型",
                    "column": "member_type",
                    "type": "radio",
                    "value": this.memberType,
                    "placeholder": "请输入会员类型...",
                    "rules": [
                        {
                            "type": "required",
                            "trigger": "change",
                            "msg": "会员类型不能为空"
                        }
                    ],
                    
                    "state": null,
                    "msg": "",
                    "show": false
                },
                {
                    "label": "性别",
                    "column": "sex",
                    "type": "radio",
                    "value": null,
                    "placeholder": "请输入性别...",
                    "rules": [
                        {
                            "type": "required",
                            "trigger": "change",
                            "msg": "性别不能为空"
                        }
                    ],
                    "options":[{"text":"男","value":"男"},{"text":"女","value":"女"}],
                    "state": null,
                    "msg": "",
                    "show": true
                },
                {
                    "label": "网站编码",
                    "column": "website_no",
                    "type": "text",
                    "value": store.getters.getWebConfig.website_no,
                    "placeholder": "请输入网站编码...",
                    "rules": [
                        {
                            "type": "required",
                            "trigger": "change",
                            "msg": "网站编码不能为空"
                        }
                    ],
                    "state": null,
                    "msg": "",
                    "show": false
                },
                {
                    "label": "联系电话",
                    "column": "phone_no",
                    "type": "text",
                    "value": null,
                    "placeholder": "请输入联系电话...",
                    "rules": [
                        {
                            "type": "required",
                            "trigger": "change",
                            "msg": "联系电话不能为空"
                        }
                    ],
                    "state": null,
                    "msg": "",
                    "show": true
                }
            ]
        }
    },
    created(){
        // console.log(this.webConfig)
    },
    mounted(){
        if(this.$route.params.type){
            this.loadType = this.$route.params.type
        }
        // this.buildFormFields()
    },
    methods:{
        onSubmit(evt) {
            let values = {}
            for(let field of this.formFields){
                values[field.column] = field.value
                // field.state(field.value)
            }
            this.validFeedback()
            
            if(Object.keys(values).length == Object.values(values).filter(item => item).length){
                let req =  [
                    {
                        "serviceName": this.serviceName,
                        "data": [
                            values
                        ]
                    }
                ]
                setRequest(req,'operate',this.serviceName,this.app).then(res=>{
                    console.log(res.data)
                    if(res.state == 'SUCCESS'){
                        this.submit = true
                        let self = this
                        // console.log(this)
                        this.$bvModal.msgBoxConfirm('注册成功.', {
                                title: '请确认',
                                size: 'sm',
                                buttonSize: 'sm',
                                okVariant: 'primary',
                                okTitle: '前往登录',
                                cancelTitle: '取消',
                                footerClass: 'p-2',
                                hideHeaderClose: false,
                                centered: true
                            })
                        .then(value => {
                            console.log(value)
                            if(value == true){
                                self.$router.replace({path:'/login' })
                            }
                        })
                        .catch(err => {
                            // An error occurred
                        })
                    }
                })    

            }
            console.log(values)
        },
        onReset(evt) {
            evt.preventDefault()
            // Reset our form values
            this.form.email = ''
            this.form.name = ''
            this.form.food = null
            this.form.checked = []
            // Trick to reset/clear native browser form validation state
            this.show = false
            this.$nextTick(() => {
                this.show = true
            })
        },
        goBack(){
            this.$router.go(-1)
        },
        buildFormFields(){
            let serviceName = this.serviceName
            let app = this.app
            if(serviceName && app){
                let v2Req = {
                    "serviceName": "srvsys_service_columnex_v2_select",
                    "colNames": [
                        "*"
                    ],
                    "condition": [
                        {
                        "colName": "service_name",
                        "value": serviceName,
                        "ruleType": "eq"
                        },
                        {
                        "colName": "use_type",
                        "value": this.formType,
                        "ruleType": "eq"
                        }
                    ],
                    "order": [
                        {
                        "colName": "seq",
                        "orderType": "asc"
                        }
                    ]
                }
                getV2(v2Req,app).then(res =>{
                    console.log(res,app)
                })
            }
        }
    }

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  .web-register{
    width: 100vw;
    height: 100vh;
    .web-register-hander{
        .copyright{
            width: 100vw;
            justify-content: center;
        }
        .logo{
             height: 40px;
        }
    } 
    .register-layout{
        // height: calc(100vh - 90px);
        width:100%;
    }
  }
  </style>
  